
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/infos-legales/confidentialite",
      function () {
        return require("private-next-pages/infos-legales/confidentialite.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/infos-legales/confidentialite"])
      });
    }
  